import request from '@/utils/request'


export function addCustomer(data) {
    return request({
        url: `api/serviceCenter/customer/addCustomer`,
        method: 'post',
        data,
    })
}

export function upDateCustomer(data) {
    return request({
        url: `api/serviceCenter/customer/upDateCustomer`,
        method: 'post',
        data,
    })
}


export function selectCustomer(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/customer/selectCustomer?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function bathDeleteCustomer(data) {
    return request({
        url: `api/serviceCenter/customer/bathDeleteCustomer`,
        method: 'post',
        data,
    })
}



